import { encrypt, decrypt } from './encryption';

const STORAGE_KEYS = {
    USER: 'easy_massage_user',
    TOKENS: 'easy_massage_tokens',
    TIMESTAMP: 'easy_massage_last_sync',
};

/**
 * @param {string} key
 * @param {any} data
 */
export const saveToLocalStorage = (key, data) => {
    try {
        const encryptedData = encrypt({ value: data, stringify: true });
        localStorage.setItem(key, encryptedData);
        localStorage.setItem(STORAGE_KEYS.TIMESTAMP, Date.now().toString());
    } catch (error) {
        console.error('[Storage] Failed to save to localStorage:', error);
    }
};

/**
 * @param {string} key
 * @returns {any}
 */
export const getFromLocalStorage = (key) => {
    try {
        const encryptedData = localStorage.getItem(key);
        if (!encryptedData) return null;

        const decrypted = decrypt({ value: encryptedData, parse: true });

        if (decrypted === false) {
            console.error('[Storage] Failed to decrypt data from localStorage');
            return null;
        }

        return decrypted;
    } catch (error) {
        console.error('[Storage] Failed to get from localStorage:', error);
        return null;
    }
};

/**
 * @param {string} key
 */
export const removeFromLocalStorage = (key) => {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        console.error('[Storage] Failed to remove from localStorage:', error);
    }
};

export const clearAllLocalStorage = () => {
    try {
        Object.values(STORAGE_KEYS).forEach((key) => {
            localStorage.removeItem(key);
        });
    } catch (error) {
        console.error('[Storage] Failed to clear localStorage:', error);
    }
};

/**
 * @param {number} maxAgeMs
 * @returns {boolean}
 */
export const isLocalStorageValid = (maxAgeMs = 30 * 24 * 60 * 60 * 1000) => {
    try {
        const timestamp = localStorage.getItem(STORAGE_KEYS.TIMESTAMP);
        if (!timestamp) return false;

        const age = Date.now() - parseInt(timestamp, 10);
        return age < maxAgeMs;
    } catch (error) {
        return false;
    }
};

/**
 * @returns {Object|null}
 */
export const restoreFromLocalStorage = () => {
    try {
        if (!isLocalStorageValid()) {
            console.warn('[Storage] LocalStorage data expired');
            clearAllLocalStorage();
            return null;
        }

        const user = getFromLocalStorage(STORAGE_KEYS.USER);
        const tokens = getFromLocalStorage(STORAGE_KEYS.TOKENS);

        if (!user || !tokens) {
            return null;
        }

        return {
            user,
            tokens,
        };
    } catch (error) {
        console.error('[Storage] Failed to restore from localStorage:', error);
        return null;
    }
};

export const localStorageUtils = {
    STORAGE_KEYS,
    saveToLocalStorage,
    getFromLocalStorage,
    removeFromLocalStorage,
    clearAllLocalStorage,
    isLocalStorageValid,
    restoreFromLocalStorage,
};
